/* eslint-disable import/no-cycle */
import { getUserProfileCall } from './services';

export const getUserProfile = () => async () => getUserProfileCall();
